import React, { useState, useEffect } from 'react';

import { motion } from 'framer-motion';

import front from '../../assets/frontend.png';
import back from '../../assets/backend.png';
import resume from '../../assets/resume.png';

import AppWrap from '../../wrappers/AppWrap';

import './About.scss';

const abouts = [
  { title: 'Front End', description: 'JavaScript, HTML, CSS, React, Redux. Also have experience with SCSS, Bootstrap, Reselect, Chart.Js, Framer Motion, and Quill.', imgUrl: front },
  { title: 'Back End', description: 'Python, Flask, PostgreSQL. Also have experience with Node and Express.', imgUrl: back },
  { title: 'My Resume', description: <a href="https://docs.google.com/document/d/12yuI-7SXEM67o4VyAcyQeaZMe5eaAYoUylW8yJE8GKM/export?format=pdf">Download a PDF</a>, imgUrl: resume }
];

const About = () => {
  return (
    <>
      <h2 className='head-text' style={{ marginTop: '2rem' }}>
        Enjoys learning and solving problems.
        <br />
        <span style={{fontSize: '1.2rem', lineHeight: '2rem', textTransform: 'none'}}>
          <p style={{marginLeft: '5rem', marginRight: '5rem', marginTop: '0.5rem'}}>
          Hi, I'm a software engineer based in Chicago and a recent graduate of App Academy. <br />
          Prior to that, I worked on corporate transactions and securities at a large law firm. <br />
          When I'm not programming, you can find me taking photos or going on a hike with my dog.
          </p>
        </span>
      </h2>

      <div className='app__profiles'>
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className='app__profile-item'
            key={about.title + index}
          >
            <img src={about.imgUrl} alt={about.title}/>
            <h2 className='bold-text' style={{ marginTop: 20 }}>{about.title}</h2>
            <h2 className='p-text' style={{ marginTop: 10 }}>{about.description}</h2>
          </motion.div>
        )
        )}
      </div>
    </>
  );
}

export default AppWrap(About, 'about');
